import { Component, ElementRef, HostListener } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { QueryService } from '../services/query.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { MisdatosService } from '../services/misdatos.service';
import { ProductosService } from '../services/productos.service';
import { ToastrService } from 'ngx-toastr';
import { GlobalConstants } from '../global-constants';
import { DatePipe } from '@angular/common';
import { WebsocketService } from '../services/websocket.service';
import { LoaderService } from '../services/loader.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css',
  // Registramos la animación aquí
  animations: [
    trigger('slideInOut', [
      state(
        'cerrado',
        style({
          height: '0px',
          paddingTop: '0px',
          paddingBottom: '0px',
          opacity: 0,
          overflow: 'hidden',
        }),
      ),
      state(
        'abierto',
        style({
          height: '70vh', // '*' calcula automáticamente la altura real del contenido
          opacity: 1,
        }),
      ),
      transition('cerrado <=> abierto', animate('350ms ease-in-out')),
    ]),
  ],
})
export class FooterComponent {
  private misdatosSub!: Subscription;
  misdatos: any = {};
  private productosSub!: Subscription;
  productos: any[] = [];
  participantes: any[] = [];
  // Estado inicial del panel de detalles (empieza abierto, según tu HTML)
  panelAbierto: boolean = false;
  formFinalizar: boolean = false;
  inputsFinalizar: any = { li_total: null, li_obs: '' };
  totales: any = { totalmes: {}, totalmesanterior: {}, ultimacompra: {} };
  fechaActual = new Date();
  productos_historial: any[] = [];

  constructor(
    private elementRef: ElementRef,
    public misdatosService: MisdatosService,
    public productosService: ProductosService,
    private wsService: WebsocketService,
    private query: QueryService,
    private toastr: ToastrService,
    private http: HttpClient,
    private datePipe: DatePipe,
    private loader: LoaderService
  ) {}

  ngOnInit() {
    // Escuchamos el observable de misdatos
    this.misdatosSub = this.misdatosService.misdatos$
      .pipe(
        // 2. FILTRO: Si es null, no pasa. Solo continúa si tiene datos reales.
        filter((misdatos): misdatos is any => misdatos !== null),
      )
      .subscribe((misdatos: any) => {
        // Ya tenemos datos
        this.misdatos = misdatos;
        this.getTotalMes();
        this.getParticipantes();
      });

    // Escuchamos el observable de los productos
    this.productosSub = this.productosService.productos$
      .pipe(
        // 2. FILTRO: Si es null, no pasa. Solo continúa si tiene datos reales.
        filter((productos): productos is any => productos !== null),
      )
      .subscribe((productos: any) => {
        // Ya tenemos datos
        this.productos = productos;
      });

    this.getProductosHistorial();
  }

  getProductosCheck(check: string = '') {
    return this.productos.filter((item) => item.pr_check === check);
  }

  getProductosUsuario(id_user: number = 0) {
    return this.productos.filter((item) => item.pr_id_user === id_user);
  }
  
  getParticipantes() {
    this.query
      .query('productos', 'PARTICIPANTES', null)
      .subscribe((resultado: any) => {
        this.participantes = resultado.registros;
        this.participantes.forEach((usuario: any) => {
          this.checkOnline(usuario);
        });
      });
  }

  getProgresoCompra() {
    // Añadimos una validación por si el array está vacío, evitando dividir por 0 (NaN)
    if (!this.productos || this.productos.length === 0) {
      return 0;
    }

    return Math.round(
      (this.getProductosCheck('X').length * 100) / this.productos.length,
    );
  }

  finalizarCompra() {
    this.formFinalizar = !this.formFinalizar;
  }

  finalizar() {
    if (this.getProductosCheck('X').length == 0) {
      this.toastr.error(`No hay productos en la cesta`);
      return;
    }
    if (this.inputsFinalizar.li_total == 0 || this.inputsFinalizar.li_obs == '') {
      this.toastr.error(`Pon el importe y el lugar de compra`);
      return;
    } 
    this.loader.show();
    this.finalizarCompra();
    this.query
      .query('productos', 'FINALIZARCOMPRA', {
        li_id: this.productos[0].pr_li_id,
        li_total: this.inputsFinalizar.li_total,
        li_obs: this.inputsFinalizar.li_obs,
        productos: this.productos
      })
      .subscribe((resultado: any) => {
        this.loader.hide();
        this.togglePanel();
        this.sendNotificacion('GETPRODUCTOS_ALLUSERS');
        this.sendNotificacion('GETPRODUCTOS', this.misdatos.first_name + ' ha finalizado la compra actual');
      });
  }

  getTotalMes() {
    this.query
      .query('productos', 'TOTALMES', null)
      .subscribe((resultado: any) => {        
        this.totales.totalmes = resultado.totalmes;
        this.totales.totalmesanterior = resultado.totalmesanterior;
        this.totales.ultimacompra = resultado.ultimacompra;
      });
  }

  togglePanel(): void {
    this.getProductosHistorial();
    this.getTotalMes();
    this.getParticipantes();
    this.panelAbierto = !this.panelAbierto;
  }

  // ESCUCHADOR DE CLICS GLOBALES
  @HostListener('document:click', ['$event'])
  clicFuera(event: MouseEvent): void {
    // Si el panel ya está cerrado, no hace falta evaluar nada
    if (!this.panelAbierto) return;

    // Comprobamos si el elemento clickeado está DENTRO del componente
    const clicDentro = this.elementRef.nativeElement.contains(event.target);

    // Si el clic fue fuera, cerramos el panel automáticamente
    if (!clicDentro) {
      this.panelAbierto = false;
    }
  }

// ESCUCHADOR DE CLICS GLOBALES EN FASE DE CAPTURA
  /*@HostListener('document:click.capture', ['$event'])
  clicFuera2(event: Event): void { // <-- Cambiado de MouseEvent a Event
    // Si el panel ya está cerrado, no evaluamos nada
    if (!this.panelAbierto) return;

    // Comprobamos si el elemento clickeado está DENTRO del componente
    const clicDentro = this.elementRef.nativeElement.contains(event.target as Node);

    // Si el clic fue fuera...
    if (!clicDentro) {
      // 1. Detenemos el evento de inmediato
      event.stopPropagation();
      event.preventDefault();
      
      // 2. Cerramos el panel automáticamente
      this.panelAbierto = false;
    }
  }*/

  /*// ESCUCHADOR DE SCROLL GLOBAL
  @HostListener('window:scroll', [])
  alHacerScroll(): void {
    // Si el panel ya está cerrado, no hacemos nada
    if (!this.panelAbierto) return;

    // Al detectar cualquier movimiento de scroll, cerramos el panel
    this.panelAbierto = false;
  }*/

  checkOnline(usuario: any) {
    this.http.get<any>(
      GlobalConstants.urlServer + `wp-json/custom/v1/user-online/${usuario.ID}`
    ).subscribe(res => {
      // 1. Multiplicamos por 1000 para convertir los segundos de PHP a milisegundos de JS
      const timestampPHP = res.last_activity * 1000;
      // 2. Aplicamos el DatePipe con la máscara exacta que necesitas
      const fechaFormateada = this.datePipe.transform(timestampPHP, 'yyyy-MM-dd HH:mm:ss');
      usuario.last_activity = fechaFormateada; // Resultado: 12/06/2026, 14:46:12
      usuario.online = res.online;
    });
  }

  sendNotificacion(tipo: string = '', mensaje: string = '') {
    // Enviar notificación al websocket
    const notificacion = {
      tipo: tipo,
      ID: this.misdatos.ID,
      mensaje: mensaje,
    };
    // Esto viaja al servidor Node.js
    this.wsService.enviarNotificacion(notificacion);
  }

  verCompras() {
    this.togglePanel();
    this.productosService.vista = 'C';
    //window.location.href = GlobalConstants.urlServer +  'compras';
  }

  irInicio() {
    window.location.href = GlobalConstants.urlServer;
  }

  getProductosHistorial() {
    this.query
      .query('productos', 'PRODUCTOSHISTORIAL', null)
      .subscribe((resultado: any) => {
        this.productos_historial = resultado.registros;
      });
  }

  undoAccion() {
    if (this.productos_historial.length == 0) return;
    this.query
      .query('productos', 'RESTAURARHISTORIAL', { pr_id: this.productos_historial[0].pr_id })
      .subscribe((resultado: any) => {
        this.sendNotificacion('GETPRODUCTOS_ALLUSERS');
      });
    this.toastr.success(`Se ha restaurado la última acción`);
    this.togglePanel();
  }

}
